import socketio from "socket.io-client";
import React from "react";
import { Config } from "src/helpers/context/config";
import { fetchFromStorage } from "src/helpers/context";
import { identifiers } from "src/helpers/constants/identifier";

let socketInitialize = null;
const userDetail = fetchFromStorage(identifiers.userData);

socketInitialize = socketio(Config.socketUrl, {
  jsonp: false,
  path: Config.socketPath,
  upgrade: false,
  reconnection: true,
});

export const socket = socketInitialize.connect();
// console.log("socket connect", userDetail?.id);
export const socketJoin =
  userDetail !== null &&
  socket.emit("JoinSocket", {
    user_id: userDetail?.id,
  });
// console.log("socketInitialize", socket);
export const SocketContext = React.createContext();
